<template>
  <div class="refer-share-to">
    <div v-for="(line, index) in shareBoxLineList" class="share-line" :class="[index === shareBoxLineList.length - 1 && 'share-line-last']" :key="index">
      <div
        v-for="(child, childIndex) in line"
        class="share"
        :key="childIndex"
        @click="handleShareBoxIconClick(child)"
      >
        <i class="iconfont" :class="`${child.icon}`"></i>
      </div>
    </div>
    <DialogWrapper
      class="share-qrcode-dialog"
      appendToBody
      destroyOnClose
      :titleI18nKey="shareQrCodeDialogInfo.titleKey"
      :show.sync="shareQrCodeDialogInfo.show"
      :close-on-click-modal="false"
      :hideFooter="true"
    >
      <div class="qrcode-wrapper">
        <img class="qrcode-body" :src="shareQrCodeDialogInfo.url"/>
        <div class="qrcode-alt"></div>
      </div>
    </DialogWrapper>
    <!-- 推荐角色 dialog -->
    <DialogWrapper
      class="share-content-referral-role-dialog"
      appendToBody
      :show.sync="showReferralRoleDialog"
      :titleI18nKey="`${i18nPrefix}.label.referralRoleTitle`"
      :saveBtnLabelI18nKey="`${i18nPrefix}.btn.yes`"
      :cancelBtnLabelI18nKey="`${i18nPrefix}.btn.no`"
      @save="handleSubmitIsEmployee"
      @cancel="handleSubmitNoEmployee"
      @closed="handleCloseReferralRoleDialog"
    >
      <div class="referral-role-content">{{ $t(`${i18nPrefix}.label.referralRoleTipContent`, { company: companyName}) }}</div>
    </DialogWrapper>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { addQueryInPath } from '@/utils/common'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    DialogWrapper
  },
  props: {
    isPreview: {
      type: Boolean,
      default: false
    },
    jobId: {
      required: false
    },
    isInChina: {
      type: Boolean,
      default: false
    },
    shareLink: {
      type: String,
      default: ''
    },
    submitInfoUrl: {
      type: String,
      default: ''
    },
    normalShareUrl: {
      type: String,
      default: ''
    },
    rootCompanyId: {
      required: true
    },
    companyId: {
      required: true
    },
    companyName: {
      type: String,
      default: ''
    },
    jobName: {
      type: String,
      default: ''
    },
    companyLogoPath: {
      type: String,
      default: ''
    },
    weChatShareMomentTitle: {
      type: String,
      default: ''
    },
    account: {
      required: false
    },
    shareToWeChatQrCodeUrl: {
      type: String,
      default: ''
    },
    shareToQrCodeUrl: {
      type: String,
      default: ''
    },
    hiddenReferralRoleCheck: {
      type: Boolean,
      default: false
    },
    toShowReferral: {
      type: Boolean,
      default: false
    },
    backOpenParamKey: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      ...mapGetters('account', ['getCurrentAccount', 'getCurrentSoftUser']),
      i18nPrefix: 'admin.job.editor',
      shareQrCodeDialogInfo: {
        show: false,
        url: '',
        titleKey: ''
      },
      showReferralRoleDialog: false,
      selectShareBox: null
    }
  },
  computed: {
    shareBoxLineList () {
      const qqParams = {
        url: this.getShareUrl(),
        desc: '',
        title: this.companyName,
        summary: this.jobName,
        pics: this.completeCompanyLogoPath,
        site: 'Ajinga'
      }
      const inLine = [
        {
          name: 'wechat',
          action: this.shareToWeChat,
          params: {
            site: 'wechat'
          },
          icon: 'icona-14'
        },
        {
          name: 'qq',
          path: 'http://connect.qq.com/widget/shareqq/index.html',
          params: qqParams,
          icon: 'icona-22'
        },
        {
          name: 'qzone',
          path: 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey',
          params: {
            url: this.getShareUrl(),
            desc: '',
            title: this.companyName,
            summary: this.jobName,
            pics: this.completeCompanyLogoPath,
            site: 'qzone'
          },
          icon: 'icona-3'
        },
        {
          name: 'sina',
          path: 'http://service.weibo.com/share/share.php',
          params: {
            url: this.getShareUrl(),
            pic: this.completeCompanyLogoPath,
            title: this.weChatShareMomentTitle,
            site: 'sinaminiblog'
          },
          icon: 'icona-34'
        },
        {
          name: 'qrcode',
          action: this.shareToQrCode,
          icon: 'icona-21'
        }
      ]
      const outLine = [
        {
          name: 'facebook',
          path: 'https://m.facebook.com/sharer.php',
          params: {
            u: this.getShareUrl(),
            site: 'facebook'
          },
          icon: 'icona-5'
        },
        {
          name: 'messenger',
          path: 'fb-messenger://share/',
          params: {
            link: this.getShareUrl()
          },
          icon: 'icona-56'
        },
        {
          name: 'linkedin',
          path: 'http://www.linkedin.com/shareArticle',
          params: {
            mini: true,
            url: this.getShareUrl(),
            site: 'linkedin'
          },
          icon: 'icona-7'
        },
        {
          name: 'whatsapp',
          path: 'whatsapp://send',
          params: {
            text: this.getShareUrl() + `\n\n${this.weChatShareMomentTitle}`,
            site: 'whatsapp'
          },
          icon: 'icona-67'
        },
        {
          name: 'email',
          action: this.shareToEmail,
          icon: 'iconxingzhuangjiehe'
        }
      ]
      const lineList = [inLine, outLine]
      if (!this.isInChina) {
        lineList.reverse()
      }
      return lineList
    },
    completeCompanyLogoPath () {
      if (_.includes(this.companyLogoPath, 'http')) {
        return this.companyLogoPath
      } else {
        return this.$DjangoBaseUrl(this.companyLogoPath)
      }
    },
    accountIsExits () {
      const account = this.getCurrentAccount()
      const softUser = this.getCurrentSoftUser()
      if (account?.id || softUser?.id) {
        return true
      } else {
        return false
      }
    }
  },
  created () {},
  methods: {
    ...mapActions('job', ['getJobQrCode', 'countShareTimes']),
    ...mapActions('eventTrack', ['trackCandidateShareJobDetail']),
    handleShareBoxIconClick (shareBoxItem) {
      if (this.isPreview) {
        return
      }
      if (!this.accountIsExits && !this.hiddenReferralRoleCheck) {
        this.showReferralRoleDialog = true
        this.selectShareBox = shareBoxItem
        return
      }
      this.handleShare(shareBoxItem)
    },
    handleShare (shareBoxItem) {
      if (this.jobId) {
        this.trackCandidateShareJobDetail({
          job_id: this.jobId
        })
      }
      if (shareBoxItem.action) {
        shareBoxItem.action()
      } else {
        const shareLink = addQueryInPath(shareBoxItem.path, shareBoxItem.params)
        if (shareBoxItem.params.site) {
          this.countShareTimesWithSite(shareBoxItem.params.site)
        }
        window.open(shareLink)
      }
    },
    async shareToWeChat () {
      this.countShareTimesWithSite('wechat')
      // PC JD 分享使用二维码自动登录后分享
      this.shareQrCodeDialogInfo.url = `/django_rest/share-job/login/qr-code/?company_id=${this.companyId}&redirect_url=${encodeURIComponent(this.shareToWeChatQrCodeUrl)}`
      this.shareQrCodeDialogInfo.titleKey = `${this.i18nPrefix}.label.shareToWeChatLogin`
      this.shareQrCodeDialogInfo.show = true
    },
    shareToQrCode () {
      if (this.jobId) {
        this.countShareTimesWithSite('qrcode')
        const shareUrl = this.getShareUrl()
        this.getJobQrCode({ jobId: this.jobId, shareUrl }).then(resp => {
          if (resp && resp.status === 'success') {
            this.shareQrCodeDialogInfo.url = resp.qr_code + '?_=' + (new Date()).getTime()
          }
        })
      } else {
        this.shareQrCodeDialogInfo.url = this.shareToQrCodeUrl
      }

      this.shareQrCodeDialogInfo.titleKey = `${this.i18nPrefix}.label.referralQrCodeTip`
      this.shareQrCodeDialogInfo.show = true
    },
    shareToEmail () {
      const referralUrl = this.getShareUrl()
      window.location.href = `mailto:?body=${encodeURIComponent(referralUrl)}`
    },
    handleSubmitIsEmployee () {
      // 员工跳转登录, backOpenParamKey 登录成功后回调直接打开分享弹窗
      let backUrl = window.location.href
      if (backUrl.includes('#=')) {
        backUrl = `${backUrl}&${this.backOpenParamKey}=1`
      } else {
        backUrl = `${backUrl}?${this.backOpenParamKey}=1`
      }

      window.location.href = `/passport/employee/register/?from_job=1&back=${encodeURIComponent(backUrl)}&company_id=${this.rootCompanyId}`
    },
    handleSubmitNoEmployee () {
      if (this.toShowReferral) {
        let backUrl = window.location.href
        if (backUrl.includes('#=')) {
          backUrl = `${backUrl}&${this.backOpenParamKey}=1`
        } else {
          backUrl = `${backUrl}?${this.backOpenParamKey}=1`
        }
        window.location.href = `/passport/candidate/register/?back=${encodeURIComponent(backUrl)}`
        return
      }
      if (this.selectShareBox) {
        this.handleShare(this.selectShareBox)
      }
    },
    handleCloseReferralRoleDialog () {
      this.showReferralRoleDialog = false
    },
    getShareUrl () {
      if (this.shareLink) {
        return this.shareLink
      } else if (this.account && this.account.id) {
        return this.submitInfoUrl
      } else {
        return this.normalShareUrl || window.location.href
      }
    },
    countShareTimesWithSite (site) {
      if (!this.jobId) {
        return
      }
      const jobId = this.jobId
      this.countShareTimes({ job_id: jobId, channel: site })
    }
  }
}
</script>

<style lang="scss" scoped>
.refer-share-to {
  .share-line {
    display: flex;
    margin-bottom: 16px;
    justify-content: space-between;
    align-items: center;

    .share {
      line-height: 1;
      cursor: pointer;

      .iconfont {
        font-size: 32px;
        color: var(--custom-color);

      }
      &:hover {
        box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
      }
    }
  }

  .share-line-last {
    margin-bottom: 0;
  }
}

.share-qrcode-dialog {
  .qrcode-wrapper {
    text-align: center;
    img {
      width: 300px;
    }
  }
}
</style>

<style lang="scss">
.share-content-referral-role-dialog {
  font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
  .referral-role-content {
    min-height: 80px;
    font-size: 14px;
    font-weight: 400;
    color: #303313;
  }
  .el-dialog__footer {
    .dialog-footer {
      .cancel-btn {
        background-color: var(--custom-color);
        color: #fff;
        border: 1px solid var(--custom-color);
      }
      .save-btn {
        background-color: var(--custom-color);
        color: #fff;
        border: 1px solid var(--custom-color);

        &:hover {
          background: var(--custom-color);
          border-color: var(--custom-color);
        }
      }
    }
  }
}
</style>
